import * as React from "react";
import { Link, RouteComponentProps } from "react-router-dom";
import {
  ListItem,
  Avatar,
  Typography,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Button
} from "@material-ui/core";
import { Report } from "src/api/classes";
import * as moment from "moment";
import FolderIcon from "@material-ui/icons/Folder";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { withRouter } from "react-router-dom";
import { DEFAULT_AVATAR } from "src/auth/auth";

interface Props extends RouteComponentProps<Pro> {
  report: Report;
}
interface Pro {}

interface State {}
const options = ["Edit"];

class ReportListItem extends React.Component<Props, State> {
  state = {
    anchorEl: null
  };
  renderSource(status) {
    let color = "#ffffff00",
      text = "status";
    if (status === "twitter:message") {
      color = "#1da1f2";
      text = "Twitter DM";
    } else if (status === "twitter:mention") {
      color = "#1da1f2";
      text = "Twitter";
    } else if (status === "whatsapp") {
      color = "#25d366";
      text = "WhatsApp";
    } else if (status === "facebook:message") {
      color = "#3b5998";
      text = "Facebook";
    }
    return (
      <Typography
        style={{
          marginLeft: 16,
          backgroundColor: color,
          color: "white",
          padding: 2,
          paddingLeft: 8,
          paddingRight: 8,
          borderRadius: 6,
          fontSize: 14,
          alignSelf: "flex-end"
        }}
        variant="caption"
      >
        {text}
      </Typography>
    );
  }
  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };
  handleClose = () => {
    this.setState({ anchorEl: null });
  };
  renderOptions() {
    const open = Boolean(this.state.anchorEl);
    return (
      <div>
        <IconButton onClick={this.handleClick}>
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="long-menu"
          anchorEl={this.state.anchorEl}
          open={open}
          onClose={this.handleClose}
          PaperProps={{
            style: {
              maxHeight: 48 * 4.5,
              width: 200
            }
          }}
        >
          {options.map(option => (
            <MenuItem
              key={option}
              selected={option === "Pyxis"}
              onClick={this.handleClose}
            >
              {option}
            </MenuItem>
          ))}
        </Menu>
      </div>
    );
  }
  render() {
    const i = this.props.report;
    return (
      <ListItem
        key={i.id}
        style={{
          paddingTop: 24,
          paddingLeft: 8,
          paddingRight: 8,
          paddingBottom: 0
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column"
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              marginBottom: 8
            }}
          >
            <Avatar
              style={{ width: 20, height: 20 }}
              src={i.account_picture || DEFAULT_AVATAR}
            />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                flex: 1
              }}
            >
              <Typography style={{ marginLeft: 8 }} variant="body2">
                {i.account_name}
              </Typography>
              <Typography style={{ marginLeft: 8, flex: 1 }} variant="caption">
                {moment(i.created_at).fromNow()}
              </Typography>
            </div>
            {this.renderSource(i.source)}
          </div>
          <Typography
            style={{
              fontSize: 13,
              overflowWrap: "break-word",
              wordBreak: "break-all"
            }}
            variant="body2"
          >
            {i.text}
          </Typography>
          <div>
            <Button
              variant="outlined"
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginTop: 16,
                fontSize: 16,
                textTransform: "none"
              }}
              onClick={() => this.props.history.push("/case/" + i.case_id)}
            >
              <FolderIcon color="action" />
              <Typography
                variant="body1"
                style={{ flex: 1, fontSize: 16, marginLeft: 8 }}
              >
                {i.case_title}
              </Typography>
            </Button>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              marginBottom: 12,
              flex: 1
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                flex: 1
              }}
            >
              <Typography variant="caption">#{i.id}</Typography>
              <Typography style={{ marginLeft: 8, flex: 1 }} variant="caption">
                {"created " + moment(i.created_at).format("LL")}
              </Typography>
              {this.renderOptions()}
              {/* this.renderUser(i.user_id) */}
            </div>
            {/* this.renderCategory(i.category_id) */}
          </div>
          <Divider />
        </div>
      </ListItem>
    );
  }
}
export default withRouter(ReportListItem);



// WEBPACK FOOTER //
// ./src/pages/reports/reportListItem.tsx